// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vxLkjDk9wlY2xfLvdtMQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
  text-transform: capitalize;
  color: var(--grey-color-70);
}

.tQQVjne_lZIBRsh4ippy {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sC7j_hJ8U1XzPebjgBuB {
  font-size: 18px;
}

.n2lklmJtFdJHTk7_IeKW {
  cursor: pointer;
}

.xXoNdHFGr_ePZx2bNKY8 {
  display: flex;
  align-items: center;
}

.MisafrGRxIbxq60dV5X2 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gqAFMAYm74byyp0a4TMv {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.ii5iAPjYvxnp5s9N32E1 {
  width: 120px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ZlETrRQm9GWGZqofzBEI {
  display: flex;
  align-items: center;
}

.bnGxPN2lwdRI5TsJC8Jy {
  margin: 0 12px;
  color: var(--grey-gradient-end-color-10);
}

.Q3sP0D6UCioPIEcHkGtP {
  font-family: var(--font-stack-full-heavy);
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 28px;
  color: var(--grey-color-90);
}

.y1ztheyokpCGqKHiVVRG {
  background-color: var(--background-color);
  padding: 16px 32px;
  border-radius: 10px;
}

.L2wEKpa2LPEaYSqxjQTy {
  display: flex;
  gap: 8px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/LevelledFramework/LevelledFramework.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,wCAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF","sourcesContent":[".outsideLabelContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px;\n  text-transform: capitalize;\n  color: var(--grey-color-70);\n}\n\n.labelContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.frameworkLabel {\n  font-size: 18px;\n}\n\n.infoIcon {\n  cursor: pointer;\n}\n\n.levelTitlesMainContainer {\n  display: flex;\n  align-items: center;\n}\n\n.levelTitlesContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.outsideLevels {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n}\n\n.levelTitleInModalContainer {\n  width: 120px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.textAndDividerContainer {\n  display: flex;\n  align-items: center;\n}\n\n.titleDivider {\n  margin: 0 12px;\n  color: var(--grey-gradient-end-color-10);\n}\n\n.frameworkHeaderTitle {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 28px;\n  color: var(--grey-color-90);\n}\n\n.levelledFrameworkContainer {\n  background-color: var(--background-color);\n  padding: 16px 32px;\n  border-radius: 10px;\n}\n\n.scoringCategoryContainer {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outsideLabelContainer": `vxLkjDk9wlY2xfLvdtMQ`,
	"labelContainer": `tQQVjne_lZIBRsh4ippy`,
	"frameworkLabel": `sC7j_hJ8U1XzPebjgBuB`,
	"infoIcon": `n2lklmJtFdJHTk7_IeKW`,
	"levelTitlesMainContainer": `xXoNdHFGr_ePZx2bNKY8`,
	"levelTitlesContainer": `MisafrGRxIbxq60dV5X2`,
	"outsideLevels": `gqAFMAYm74byyp0a4TMv`,
	"levelTitleInModalContainer": `ii5iAPjYvxnp5s9N32E1`,
	"textAndDividerContainer": `ZlETrRQm9GWGZqofzBEI`,
	"titleDivider": `bnGxPN2lwdRI5TsJC8Jy`,
	"frameworkHeaderTitle": `Q3sP0D6UCioPIEcHkGtP`,
	"levelledFrameworkContainer": `y1ztheyokpCGqKHiVVRG`,
	"scoringCategoryContainer": `L2wEKpa2LPEaYSqxjQTy`
};
export default ___CSS_LOADER_EXPORT___;
